import React, { useEffect, useRef, useState } from 'react'
import $ from "jquery";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import jszip from "jszip";
import { Link } from 'react-router-dom';
pdfMake.vfs = pdfFonts.vfs;

const Notifications = () => {
    // Modal states
    const [showViewModal, setShowViewModal] = useState(false);
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedNotification, setSelectedNotification] = useState(null);
    const [scheduleLater, setScheduleLater] = useState(false);
    const [showSpecificUser, setShowSpecificUser] = useState(false);
    
    // Form data
    const [formData, setFormData] = useState({
        subject: '',
        message: '',
        recipient: '',
        specificEmail: '',
        scheduleDate: '',
        scheduleTime: ''
    });

    const tableRef = useRef(null);

    useEffect(() => {
        window.JSZip = jszip;

        let table;

        if (tableRef.current && !$.fn.DataTable.isDataTable('#notificationsTable')) {
            table = $(tableRef.current).DataTable({
                responsive: true,
                pageLength: 5,
                lengthChange: false,
                ordering: true,
                order: [[3, 'desc']],
                destroy: true,
                dom: "<'row mb-3'<'col-sm-12 col-md-12'f>>" +
                     "<'row'<'col-sm-12'tr>>" +
                     "<'row mt-3'<'col-sm-12 col-md-12'i><'col-sm-12 col-md-12'B p>>",
                buttons: [
                    { extend: "copy", text: "Copy" },
                    { extend: "excel", text: "Excel" },
                    { extend: "pdf", text: "PDF" },
                    { extend: "print", text: "Print" },
                ],
            });
        }

        return () => {
            if (table) table.destroy();
        };
    }, []);

    // Handle link clicks
    const handleLinkClick = (e, callback) => {
        e.preventDefault();
        if (callback) callback();
    };

    // Open View Modal
    const openViewModal = (notification) => {
        setSelectedNotification(notification);
        setShowViewModal(true);
    };

    // Close View Modal
    const closeViewModal = () => {
        setShowViewModal(false);
        setSelectedNotification(null);
    };

    // Open Create Modal
    const openCreateModal = () => {
        setFormData({
            subject: '',
            message: '',
            recipient: '',
            specificEmail: '',
            scheduleDate: '',
            scheduleTime: ''
        });
        setShowSpecificUser(false);
        setScheduleLater(false);
        setShowCreateModal(true);
    };

    // Open Edit Modal with data
    const openEditModal = (notification) => {
        setFormData({
            subject: notification.subject,
            message: notification.message,
            recipient: notification.recipient,
            specificEmail: '',
            scheduleDate: '',
            scheduleTime: ''
        });
        setShowSpecificUser(notification.recipient === 'Specific User (john.doe@ex.com)');
        setScheduleLater(false);
        setShowCreateModal(true);
    };

    // Close Create Modal
    const closeCreateModal = () => {
        setShowCreateModal(false);
        setFormData({
            subject: '',
            message: '',
            recipient: '',
            specificEmail: '',
            scheduleDate: '',
            scheduleTime: ''
        });
        setScheduleLater(false);
        setShowSpecificUser(false);
    };

    // Open Delete Modal
    const openDeleteModal = (notification) => {
        setSelectedNotification(notification);
        setShowDeleteModal(true);
    };

    // Close Delete Modal
    const closeDeleteModal = () => {
        setShowDeleteModal(false);
        setSelectedNotification(null);
    };

    // Handle form input changes
    const handleInputChange = (e) => {
        const { id, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [id]: value
        }));
    };

    const handleRecipientChange = (e) => {
        const value = e.target.value;
        setFormData(prev => ({
            ...prev,
            recipient: value
        }));
        setShowSpecificUser(value === 'Specific User');
    };

    // Send notification
    const sendNotification = () => {
        alert('Notification sent successfully!');
        closeCreateModal();
    };

    // Save as draft
    const saveAsDraft = () => {
        alert('Saved as draft successfully!');
        closeCreateModal();
    };

    // Confirm Delete
    const confirmDelete = () => {
        alert(`${selectedNotification?.subject} deleted successfully!`);
        closeDeleteModal();
    };

    // Get status badge class
    const getStatusBadgeClass = (status) => {
        switch(status) {
            case 'Sent': return 'badge bg-success';
            case 'Scheduled': return 'badge bg-warning text-dark';
            case 'Draft': return 'badge bg-secondary';
            default: return 'badge bg-primary';
        }
    };

    return (
        <>
            <div className="page-wrapper">
                <div className="page-content">
                    {/*breadcrumb*/}
                    <div className="page-breadcrumb d-flex align-items-center mb-3">
                        <div className="breadcrumb-title pe-3 d-none d-xl-block d-lg-block d-md-block">Notifications</div>
                        <div className="ps-3 d-none d-xl-block d-lg-block d-md-block">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb mb-0 p-0">
                                    <li className="breadcrumb-item">
                                        <Link to="/">
                                            <i className="bx bx-home-alt"></i>
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">Notifications</li>
                                </ol>
                            </nav>
                        </div>
                        <div className="ms-auto">
                            {/* Create button triggers new notification modal */}
                            <button type="button" className="btn btn-primary d-flex align-items-center" onClick={openCreateModal}>
                                <i className="bx bx-plus me-2"></i>Create
                            </button>
                        </div>
                    </div>
                    <hr />
                    {/* Notifications card */}
                    <div className="card">
                        <div className="card-body">
                            <div className="entries-wrapper mb-3 home-entress">
                                <label className="entries-label">
                                    <span>Showing</span>
                                    <select className="entries-select">
                                        <option value="10" selected>10</option>
                                        <option value="25">25</option>
                                        <option value="50">50</option>
                                        <option value="100">100</option>
                                    </select>
                                    <span>Entries</span>
                                </label>
                            </div>
                            <div className="tab-content">
                                <div className="tab-pane fade show active" id="notificationsPane" role="tabpanel">
                                    <div className="table-responsive">
                                        <table id="notificationsTable" className="table table-striped table-bordered" style={{width: '100%'}} ref={tableRef}>
                                            <thead>
                                                <tr>
                                                    <th>Subject</th>
                                                    <th>Message</th>
                                                    <th>Recipient</th>
                                                    <th>Date & Time</th>
                                                    <th>Status</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {/* Sample row 1 */}
                                                <tr>
                                                    <td>League Match Update</td>
                                                    <td>Match timings updated for all referees.</td>
                                                    <td>All Users</td>
                                                    <td>22 Aug 2026 | 10:00 AM</td>
                                                    <td>
                                                        <span className={getStatusBadgeClass('Sent')}>Sent</span>
                                                    </td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex align-items-center gap-2 list-unstyled mb-0">
                                                            <li>
                                                                <a href="#" onClick={(e) => handleLinkClick(e, () => openViewModal({
                                                                    subject: 'League Match Update',
                                                                    message: 'Match timings updated for all referees.',
                                                                    recipient: 'All Users',
                                                                    dateTime: '22 Aug 2026 | 10:00 AM'
                                                                }))}>
                                                                    <i className="lni lni-eye" title="View"></i>
                                                                </a>
                                                            </li>
                                                            <li>
                                                                <a href="#" onClick={(e) => handleLinkClick(e, () => openDeleteModal({
                                                                    subject: 'League Match Update'
                                                                }))}>
                                                                    <i className="bx bx-trash" data-bs-toggle="tooltip" title="Delete"></i>
                                                                </a>
                                                            </li>
                                                            <li>
                                                                <a href="#" onClick={(e) => handleLinkClick(e, () => openEditModal({
                                                                    subject: 'League Match Update',
                                                                    message: 'Match timings updated for all referees.',
                                                                    recipient: 'All Users'
                                                                }))}>
                                                                    <i className="bx bx-send" title="Send now"></i>
                                                                </a>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                {/* Sample row 2 */}
                                                <tr>
                                                    <td>Practice Session Notification</td>
                                                    <td>Evening practice moved to 5 PM.</td>
                                                    <td>Coaches</td>
                                                    <td>23 Aug 2026 | 02:00 PM</td>
                                                    <td>
                                                        <span className={getStatusBadgeClass('Scheduled')}>Scheduled</span>
                                                    </td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex align-items-center gap-2 list-unstyled mb-0">
                                                            <li>
                                                                <a href="#" onClick={(e) => handleLinkClick(e, () => openViewModal({
                                                                    subject: 'Practice Session Notification',
                                                                    message: 'Evening practice moved to 5 PM.',
                                                                    recipient: 'Coaches',
                                                                    dateTime: '23 Aug 2026 | 02:00 PM'
                                                                }))}>
                                                                    <i className="lni lni-eye"></i>
                                                                </a>
                                                            </li>
                                                            <li>
                                                                <a href="#" onClick={(e) => handleLinkClick(e, () => openDeleteModal({
                                                                    subject: 'Practice Session Notification'
                                                                }))}>
                                                                    <i className="bx bx-trash" data-bs-toggle="tooltip" title="Delete"></i>
                                                                </a>
                                                            </li>
                                                            <li>
                                                                <a href="#" onClick={(e) => handleLinkClick(e, () => openEditModal({
                                                                    subject: 'Practice Session Notification',
                                                                    message: 'Evening practice moved to 5 PM.',
                                                                    recipient: 'Coaches'
                                                                }))}>
                                                                    <i className="bx bx-send"></i>
                                                                </a>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                {/* Sample row 3 */}
                                                <tr>
                                                    <td>Parent Meeting Reminder</td>
                                                    <td>Zoom link for parent meeting</td>
                                                    <td>Specific User (john.doe@ex.com)</td>
                                                    <td>25 Aug 2026 | 05:30 PM</td>
                                                    <td>
                                                        <span className={getStatusBadgeClass('Draft')}>Draft</span>
                                                    </td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex align-items-center gap-2 list-unstyled mb-0">
                                                            <li>
                                                                <a href="#" onClick={(e) => handleLinkClick(e, () => openViewModal({
                                                                    subject: 'Parent Meeting Reminder',
                                                                    message: 'Zoom link for parent meeting',
                                                                    recipient: 'Specific User (john.doe@ex.com)',
                                                                    dateTime: '25 Aug 2026 | 05:30 PM'
                                                                }))}>
                                                                    <i className="lni lni-eye"></i>
                                                                </a>
                                                            </li>
                                                            <li>
                                                                <a href="#" onClick={(e) => handleLinkClick(e, () => openDeleteModal({
                                                                    subject: 'Parent Meeting Reminder'
                                                                }))}>
                                                                    <i className="bx bx-trash" data-bs-toggle="tooltip" title="Delete"></i>
                                                                </a>
                                                            </li>
                                                            <li>
                                                                <a href="#" onClick={(e) => handleLinkClick(e, () => openEditModal({
                                                                    subject: 'Parent Meeting Reminder',
                                                                    message: 'Zoom link for parent meeting',
                                                                    recipient: 'Specific User'
                                                                }))}>
                                                                    <i className="bx bx-send"></i>
                                                                </a>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                {/* Sample row 4 */}
                                                <tr>
                                                    <td>New Referee Onboarding</td>
                                                    <td>Please complete the training module</td>
                                                    <td>Hired Referees</td>
                                                    <td>26 Aug 2026 | 09:00 AM</td>
                                                    <td>
                                                        <span className={getStatusBadgeClass('Sent')}>Sent</span>
                                                    </td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex align-items-center gap-2 list-unstyled mb-0">
                                                            <li>
                                                                <a href="#" onClick={(e) => handleLinkClick(e, () => openViewModal({
                                                                    subject: 'New Referee Onboarding',
                                                                    message: 'Please complete the training module',
                                                                    recipient: 'Hired Referees',
                                                                    dateTime: '26 Aug 2026 | 09:00 AM'
                                                                }))}>
                                                                    <i className="lni lni-eye"></i>
                                                                </a>
                                                            </li>
                                                            <li>
                                                                <a href="#" onClick={(e) => handleLinkClick(e, () => openDeleteModal({
                                                                    subject: 'New Referee Onboarding'
                                                                }))}>
                                                                    <i className="bx bx-trash" data-bs-toggle="tooltip" title="Delete"></i>
                                                                </a>
                                                            </li>
                                                            <li>
                                                                <a href="#" onClick={(e) => handleLinkClick(e, () => openEditModal({
                                                                    subject: 'New Referee Onboarding',
                                                                    message: 'Please complete the training module',
                                                                    recipient: 'Hired Referees'
                                                                }))}>
                                                                    <i className="bx bx-send"></i>
                                                                </a>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                {/* Sample row 5 */}
                                                <tr>
                                                    <td>Field Maintenance Alert</td>
                                                    <td>Field #3 closed due to rain</td>
                                                    <td>Club Directors</td>
                                                    <td>27 Aug 2026 | 07:15 AM</td>
                                                    <td>
                                                        <span className={getStatusBadgeClass('Scheduled')}>Scheduled</span>
                                                    </td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex align-items-center gap-2 list-unstyled mb-0">
                                                            <li>
                                                                <a href="#" onClick={(e) => handleLinkClick(e, () => openViewModal({
                                                                    subject: 'Field Maintenance Alert',
                                                                    message: 'Field #3 closed due to rain',
                                                                    recipient: 'Club Directors',
                                                                    dateTime: '27 Aug 2026 | 07:15 AM'
                                                                }))}>
                                                                    <i className="lni lni-eye"></i>
                                                                </a>
                                                            </li>
                                                            <li>
                                                                <a href="#" onClick={(e) => handleLinkClick(e, () => openDeleteModal({
                                                                    subject: 'Field Maintenance Alert'
                                                                }))}>
                                                                    <i className="bx bx-trash" data-bs-toggle="tooltip" title="Delete"></i>
                                                                </a>
                                                            </li>
                                                            <li>
                                                                <a href="#" onClick={(e) => handleLinkClick(e, () => openEditModal({
                                                                    subject: 'Field Maintenance Alert',
                                                                    message: 'Field #3 closed due to rain',
                                                                    recipient: 'Club Directors'
                                                                }))}>
                                                                    <i className="bx bx-send"></i>
                                                                </a>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* View Notification Modal */}
            {showViewModal && (
                <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">View Notification</h5>
                                <button type="button" className="btn-close" onClick={closeViewModal}></button>
                            </div>
                            <div className="modal-body">
                                <div className="mb-3">
                                    <label className="form-label">Subject</label>
                                    <input type="text" className="form-control" readOnly value={selectedNotification?.subject || ''} />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Recipient</label>
                                    <input type="text" className="form-control" readOnly value={selectedNotification?.recipient || ''} />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Date & Time</label>
                                    <input type="text" className="form-control" readOnly value={selectedNotification?.dateTime || ''} />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Message Body</label>
                                    <textarea className="form-control" rows="4" readOnly value={selectedNotification?.message || ''}></textarea>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={closeViewModal}>Close</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Create / Edit Notification Modal */}
            {showCreateModal && (
                <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">{formData.subject ? 'Edit Notification' : 'Create Notification'}</h5>
                                <button type="button" className="btn-close" onClick={closeCreateModal}></button>
                            </div>
                            <div className="modal-body">
                                <form id="notificationForm">
                                    {/* Recipient Dropdown */}
                                    <div className="mb-3">
                                        <label className="form-label">Recipient <span className="text-danger">*</span></label>
                                        <select className="form-select" id="recipient" value={formData.recipient} onChange={handleRecipientChange} required>
                                            <option value="" disabled>-- Select recipient --</option>
                                            <option value="All Users">All Users</option>
                                            <option value="Club Directors">Club directors</option>
                                            <option value="Hired Referees">Referees</option>
                                            <option value="Coaches">Coaches</option>
                                            <option value="Specific User">Parents</option>
                                        </select>
                                        {/* optional specific user email */}
                                        {showSpecificUser && (
                                            <div className="mt-2">
                                                <input type="email" className="form-control" id="specificEmail" placeholder="Enter user email" value={formData.specificEmail} onChange={handleInputChange} />
                                            </div>
                                        )}
                                    </div>
                                    {/* Subject */}
                                    <div className="mb-3">
                                        <label className="form-label">Subject</label>
                                        <input type="text" className="form-control" id="subject" placeholder="Meeting reminder..." value={formData.subject} onChange={handleInputChange} required />
                                    </div>
                                    {/* Message Body */}
                                    <div className="mb-3">
                                        <label className="form-label">Message Body</label>
                                        <textarea className="form-control" id="message" rows="4" placeholder="Write your message..." value={formData.message} onChange={handleInputChange} required></textarea>
                                    </div>
                                    {/* Schedule for Later toggle */}
                                    <div className="mb-3">
                                        <div className="form-check form-switch">
                                            <input className="form-check-input" type="checkbox" id="scheduleToggle" checked={scheduleLater} onChange={(e) => setScheduleLater(e.target.checked)} />
                                            <label className="form-check-label" htmlFor="scheduleToggle">Schedule for later</label>
                                        </div>
                                    </div>
                                    {/* date & time picker */}
                                    {scheduleLater && (
                                        <div className="row">
                                            <div className="col-md-6 mb-2">
                                                <label className="form-label">Date</label>
                                                <input type="date" className="form-control" id="scheduleDate" value={formData.scheduleDate} onChange={handleInputChange} />
                                            </div>
                                            <div className="col-md-6 mb-2">
                                                <label className="form-label">Time</label>
                                                <input type="time" className="form-control" id="scheduleTime" value={formData.scheduleTime} onChange={handleInputChange} />
                                            </div>
                                        </div>
                                    )}
                                </form>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-outline-primary" onClick={saveAsDraft}>Save as Draft</button>
                                <button type="button" className="btn btn-primary" onClick={sendNotification}>Send Now</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Delete Confirmation Modal */}
            {showDeleteModal && (
                <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Confirmation Alert!</h5>
                                <button type="button" className="btn-close" onClick={closeDeleteModal}></button>
                            </div>
                            <div className="modal-body">
                                <h5>Do you want to delete this notification?</h5>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={closeDeleteModal}>No</button>
                                <button type="button" className="btn btn-danger" onClick={confirmDelete}>Yes</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default Notifications